// @flow
import {connect} from 'react-redux';
import Tools from '../components/Tools';

import type {RootState} from '../../index';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
  }),
  null
)(Tools);
